// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxField_checkbox__2DuKS","text":"CheckboxField_text__3UYdw","checkmark":"CheckboxField_checkmark__21hlc"};